var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 26,
    height: 26,
    transform: "translate(0 -0.139)",
    fill: "#152c40"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(-145.407 0.139)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(145.407 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M19.244,17.069a2.556,2.556,0,0,0-3.633,0l-1.238,1.24a22.385,22.385,0,0,1-3.855-3.1,23.036,23.036,0,0,1-3.094-3.862l1.238-1.24a2.567,2.567,0,0,0,0-3.64L6.245,4.05a2.5,2.5,0,0,0-1.8-.754A2.579,2.579,0,0,0,2.62,4.05L1.458,5.205a5.463,5.463,0,0,0-1.4,4.5c.271,3.212,2.377,7.073,5.614,10.33s7.14,5.352,10.346,5.66a6.257,6.257,0,0,0,.717,0,5.186,5.186,0,0,0,3.77-1.4l1.153-1.165a2.589,2.589,0,0,0,.752-1.825,2.511,2.511,0,0,0-.752-1.806Zm1.207,4.844-1.163,1.156a3.9,3.9,0,0,1-3.13.856c-2.779-.236-6.317-2.207-9.239-5.138S2.032,12.342,1.765,9.558A3.881,3.881,0,0,1,2.62,6.423L3.827,5.258a.86.86,0,0,1,1.21,0L7.46,7.707a.863.863,0,0,1,0,1.209L5.75,10.629a.852.852,0,0,0-.138,1.034,23.456,23.456,0,0,0,3.7,4.776,23.45,23.45,0,0,0,4.773,3.711.853.853,0,0,0,1.033-.138l1.71-1.713a.858.858,0,0,1,1.206,0l2.419,2.422a.88.88,0,0,1,.248.612.842.842,0,0,1-.248.579M21.937,3.76A12.729,12.729,0,0,0,12.878,0a.856.856,0,0,0,0,1.713A11.13,11.13,0,0,1,23.99,12.939a.855.855,0,1,0,1.71,0A12.777,12.777,0,0,0,21.937,3.76",
    transform: "translate(0 0)",
    fill: "#152c40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M15.531,7.985a5.165,5.165,0,0,1,1.514,3.693.855.855,0,1,0,1.71,0,6.848,6.848,0,0,0-6.838-6.94.856.856,0,0,0,0,1.713,5.143,5.143,0,0,1,3.615,1.535",
    transform: "translate(1.546 0.672)",
    fill: "#152c40"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/call-icon.69a822a6429eea9e809a4995b4a21e25.svg";
export { ForwardRef as ReactComponent };